module.exports = __webpack_public_path__ + "img/pulverizador.91878a93.png";